'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { scrollToSection } from '@/lib/cadrino-landing/scroll-to-section';

/** Scroll to hash target on mount (e.g. /#contact from inner pages). */
export function useHashScroll() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp, t0);
}
function _temp() {
  const hash = window.location.hash;
  if (!hash || hash.length < 2) {
    return;
  }
  const id = hash.slice(1);
  const timer = window.setTimeout(() => scrollToSection(id), 100);
  return () => window.clearTimeout(timer);
}